// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import styles from './styles'
import classNames from 'classnames'

type CellProps = {
  account?: string,
  bold?: boolean,
  button?: string,
  className?: string,
  italic?: boolean,
  mono?: boolean,
  centered?: boolean,
  status?: Object,
  type?: string,
  value: string,
}

export const Cell = (props: CellProps) => {
  const {
    className = '',
    value,
    status,
    bold,
    account,
    italic,
    mono,
    centered,
    button
  } = props
  let cellStyle = value ? styles.tdCell : styles.noValue
  if (value) {
    if (bold) {
      cellStyle = styles.boldValue
    }
    if (mono) {
      cellStyle = styles.monoValue
    }
    if (centered) {
      cellStyle = styles.centeredValue
    }
    if (italic) {
      cellStyle = styles.italicValue
    }
  }

  let innerClass
  if (status) {
    innerClass = styles[status]
  } else if (button) {
    innerClass = styles[button]
  } else if (account) {
    innerClass = styles[account]
  }

  return (
    <div className={`${cellStyle} ${className}`}>
      <span className={innerClass}>{value || '—'}</span>
    </div>
  )
}

export const HeaderCell = ({ value, type }: CellProps) => {
  let body = (
    <div>
      {value}
      <div className={styles.fixed}>{value}</div>
    </div>
  )

  if (type === 'mono') {
    body = (
      <div className={styles.floatRight}>
        {value}
        <div className={styles.fixed}>{value}</div>
      </div>
    )
  } else if (type === 'link') {
    body = (
      <div className={styles.headerLink}>{value}</div>
    )
  }

  return <div className={styles.thCell}>{body}</div>
}

type RowProps = {
  children?: Element,
  highlight?: boolean,
  link?: string,
  onClick?: Function,
  selected?: boolean,
}

export const Row = (rowProps: RowProps) => {
  const { children, highlight, link, onClick, selected } = rowProps
  let selectedStyle = selected ? styles.selected : styles.tdRow
  let highlightStyle = highlight ? styles.highlight : ''
  if (link) {
    return (
      <Link to={link} className={selectedStyle}>
        {children}
      </Link>
    )
  }
  return (
    <div onClick={onClick} className={`${selectedStyle} ${highlightStyle}`}>
      {children}
    </div>
  )
}

type TableProps = {
  children?: Element,
  headers?: Array<string>,
  isOpen?: boolean,
  title?: string,
  tableSize?: string,
  tableType?: string,
  noResults?: string,
}

export class Table extends React.Component<TableProps> {
  constructor(props: TableProps) {
    super(props)

    const headers = (
      <div className={styles.thRow}>
        {props.headers.map((header, i) => (
          <HeaderCell
            key={i}
            value={header.value || header}
            type={header.type}
          />
        ))}
      </div>
    )

    let tableSize = styles.tableMedium
    switch (props.tableSize) {
      case 'large':
        tableSize = styles.tableLarge
        break
      case 'medium':
        tableSize = styles.tableMedium
        break
      case 'small':
        tableSize = styles.tableSmall
        break
      case 'infinite':
        tableSize = undefined
        break
    }

    let tableType =
      props.tableType === 'read' ? styles.tableRead : styles.tableClick

    this.state = {
      isOpen: !!props.isOpen,
      headers,
      tableSize,
      tableType,
    }
  }
  render() {
    const { headers, tableSize } = this.state
    const { children, title } = this.props
    let tableClasses = classNames(tableSize)
    let noResults = null
    if (!children || !children.length) {
      noResults = (
        <div className={styles.noResults}>
          {(this.props.noResults == null ? 'No Results' : this.props.noResults)}
        </div>
      )
    }

    let tableTitle = <div></div>

    if (title) {
        tableTitle = <h5 className={styles.tableTitle}>{title}</h5>
    }

    let main = (
      <div className={tableClasses}>
        <div className={styles.table}>
          {headers}
          {children}
        </div>
      </div>
    )

    return (
      <section className={styles.tableSection}>
        {tableTitle}
        {main}
        {noResults}
      </section>
    )
  }
}
